import { useState } from 'react'
import { msg, Trans } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { Button, MenuItem, Tooltip } from '@mui/material'
import PermIdentityRoundedIcon from '@mui/icons-material/PermIdentityRounded'

import { useIsLargeScreen } from '@/hooks/useIsLargeScreen'
import { useIsINSEnabled } from '@/shared/model/useIsINSEnabled'
import { useGetPatientQuery } from '@/core/services/patient'
import { selectDMPConnectTlsiConnectorId } from '@/redux/reducers/dmp-connect.reducer'
import { useAppSelector } from '@/redux/rootReducer'

import { CheckInsAndIdentityDialog } from './CheckInsAndIdentityDialog'

const INS_CALL_BLOCKED_TOOLTIP = msg`The INSi call is not possible for an identity flagged as Doubtful or Fictitious`

type CheckInsAndIdentityButtonProps = {
  onClose?: () => void
  patientId: string
}

export function CheckInsAndIdentity({ onClose, patientId }: CheckInsAndIdentityButtonProps) {
  const lingui = useLingui()
  const isLargeScreen = useIsLargeScreen()
  const { data: patient } = useGetPatientQuery(patientId)
  const { isINSEnabled, isInsCallBlocked } = useIsINSEnabled(patient)
  const tlsiConnectorId = useAppSelector(selectDMPConnectTlsiConnectorId)

  const [openCheckINSAndIdentityDialog, setOpenCheckINSAndIdentityDialog] = useState(false)

  const openDialog = () => {
    if (isInsCallBlocked) return
    setOpenCheckINSAndIdentityDialog(true)
  }

  if (!isINSEnabled || !tlsiConnectorId) return null

  if (isLargeScreen) {
    const button = (
      <Button disabled={isInsCallBlocked} onClick={openDialog} variant="contained">
        <Trans>Check INS and Identity</Trans>
      </Button>
    )
    return (
      <>
        {isInsCallBlocked ? (
          <Tooltip title={lingui._(INS_CALL_BLOCKED_TOOLTIP)}>
            <span>{button}</span>
          </Tooltip>
        ) : (
          button
        )}
        <CheckInsAndIdentityDialog open={openCheckINSAndIdentityDialog} onClose={() => setOpenCheckINSAndIdentityDialog(false)} />
      </>
    )
  }

  return (
    <>
      <Tooltip title={isInsCallBlocked ? lingui._(INS_CALL_BLOCKED_TOOLTIP) : ''}>
        <MenuItem disableRipple disabled={isInsCallBlocked} onClick={openDialog}>
          <PermIdentityRoundedIcon />
          <Trans>Check INS And Identity</Trans>
        </MenuItem>
      </Tooltip>
      <CheckInsAndIdentityDialog
        open={openCheckINSAndIdentityDialog}
        onClose={() => {
          setOpenCheckINSAndIdentityDialog(false)
          onClose?.()
        }}
      />
    </>
  )
}
